module.exports = __webpack_public_path__ + "img/videowiki-room.d1afaa69.svg";